import { ReactNode } from 'react';
import { asyncContainerFactory, ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { Stack, StackItem } from '@optimus-web/core';
import { WithAccountId } from '@mews-commander/types';
import { WithPaymentPlanId } from './tables/PaymentPlans/types';
import { useGetPaymentPlanDetail } from './tables/PaymentPlans/queries';
import { PaymentPlanDetailsViewHeader } from './views/PaymentPlanDetails/PaymentPlanDetailsViewHeader';
import { PaymentPlanDetailsViewContent } from './views/PaymentPlanDetails/PaymentPlanDetailsViewContent';

const withAsyncModalWrapper = asyncContainerFactory({
    ContentElement: ModalWrapper,
});

const DetailViewWrapper = withAsyncModalWrapper(({ children }: { children: ReactNode }) => <>{children}</>);

export const PaymentPlanDetailView = ({ accountId, paymentPlanId }: WithAccountId & WithPaymentPlanId) => {
    const { data, isFetching, isError } = useGetPaymentPlanDetail({
        id: paymentPlanId,
    });

    return (
        <DetailViewWrapper isFetching={isFetching} hasFailed={isError}>
            <NewModalBodyWrapper padded>
                {data && (
                    <Stack vertical fill spacing="300" tabletMax={{ spacing: '200' }}>
                        <StackItem>
                            <PaymentPlanDetailsViewHeader
                                detail={data}
                                accountId={accountId}
                                paymentPlanId={paymentPlanId}
                            />
                        </StackItem>

                        <StackItem grow>
                            <PaymentPlanDetailsViewContent
                                detail={data}
                                accountId={accountId}
                                paymentPlanId={paymentPlanId}
                            />
                        </StackItem>
                    </Stack>
                )}
            </NewModalBodyWrapper>
        </DetailViewWrapper>
    );
};
